/* =====================================================================
   Affichage TTC suisse — socle partage
   ---------------------------------------------------------------------
   Pendant client de snippets/tax-mode.liquid, qui fait foi pour la regle.
   Le mode arrive ici par le noeud de donnees pose par
   snippets/ttc-settings.liquid :

     ttc-only : particulier livre en Suisse. Les montants reecrits par un
                script (fiche configurable) sont convertis en TTC et restent
                le seul montant affiche.
     ht-ttc   : compte pro livre en Suisse. Un second montant TTC s'ajoute
                sous le tarif HT, en ligne secondaire « soit CHF 891.83 TTC »
                (cartes, fiches, produits lies). Le HT domine : decision de
                Joris du 24 septembre 2026.
     ht       : rien.

   Ce n'est QU'UN AFFICHAGE : aucun montant calcule ici ne doit partir vers
   le panier, le checkout ou SparkLayer. Les prix transmis restent HT, c'est
   le paiement qui ajoute la TVA suisse.

   Charge SANS defer en tete de <head> : les consommateurs (cartes B2B, PDP
   simple, PDP configurable) sont des scripts de section non differes, dont
   certains s'executent avant les scripts differes du layout.
   Libelles (« soit », mention TTC par defaut) : window.FOG_I18N, pose par
   assets/i18n.js charge plus haut dans le meme <head> (snippets/i18n-js.liquid).
   ===================================================================== */

(function () {
  'use strict';

  var DEFAULTS = {
    mode: 'ht',
    rate: 8.1,
    label: window.FOG_I18N.t('cart.tax_incl_short'),
    note: ''
  };

  /* Le libelle et la note arrivent du filtre `t` (snippets/ttc-settings.liquid),
     donc deja echappes pour le HTML : « l'IVA » arriverait en « l&#39;IVA ». Ils
     sont ecrits en texte (textContent, title), on les decode une fois ici, meme
     technique qu'assets/i18n.js : un <textarea> decode les entites sans creer de
     balise ni executer quoi que ce soit. Spec 07, lot 6. */
  function decode(s) {
    if (typeof s !== 'string' || s.indexOf('&') === -1) return s;
    var ta = document.createElement('textarea');
    ta.innerHTML = s;
    return ta.value;
  }

  function readSettings() {
    var node = document.getElementById('fog-ttc-settings');
    if (!node) return DEFAULTS;
    try {
      var parsed = JSON.parse(node.textContent || '{}');
      var mode = parsed.mode === 'ttc-only' || parsed.mode === 'ht-ttc' ? parsed.mode : 'ht';
      return {
        mode: mode,
        rate: typeof parsed.rate === 'number' && parsed.rate > 0 ? parsed.rate : DEFAULTS.rate,
        label: decode(parsed.label) || DEFAULTS.label,
        note: decode(parsed.note) || DEFAULTS.note
      };
    } catch (e) {
      return DEFAULTS;
    }
  }

  var S = readSettings();
  var FACTOR = 1 + (S.rate / 100);

  /* Arrondi au centime sur le montant affiche, et sur lui seul : un TTC unitaire
     arrondi puis multiplie par la quantite ne donne pas le total de ligne TTC.
     Meme formule que snippets/price-ttc-amount.liquid. */
  function toTtcCents(htCents) {
    var n = Number(htCents);
    if (!isFinite(n) || n <= 0) return null;
    return Math.round(n * FACTOR);
  }

  /* Montant a afficher comme montant principal d'un prix public : le TTC pour un
     particulier suisse, le HT inchange partout ailleurs. */
  function displayCents(htCents) {
    if (S.mode !== 'ttc-only') return htCents;
    var ttc = toTtcCents(htCents);
    return ttc == null ? htCents : ttc;
  }

  /* Construit (ou met a jour) le second montant TTC dans un conteneur, en mode
     ht-ttc uniquement.
       container : element qui porte deja le montant HT
       htCents   : montant HT en centimes
       currency  : (optionnel) devise ISO du montant, par defaut celle du marche
     Le texte est ecrit par window.FOG_MONEY (assets/money-format.js), donc dans
     la meme forme que tous les autres montants du site.
     Retire le montant si le contexte ne s'y prete pas (autre mode, montant
     invalide), pour qu'un recalcul de configuration ne laisse jamais un TTC
     perime a l'ecran. */
  function apply(container, htCents, currency) {
    if (!container) return null;
    var existing = container.querySelector('[data-tax-incl]');
    var cents = S.mode === 'ht-ttc' ? toTtcCents(htCents) : null;

    if (cents == null) {
      if (existing && existing.parentNode) existing.parentNode.removeChild(existing);
      return null;
    }

    var text = window.FOG_MONEY
      ? window.FOG_MONEY.format(cents, currency)
      : (cents / 100).toFixed(2) + (currency ? ' ' + currency : '');
    var el = existing;

    if (!el) {
      el = document.createElement('span');
      el.className = 'tax-incl';
      el.setAttribute('data-tax-incl', '');
      if (S.note) el.title = S.note;
      /* « soit » : le TTC se lit comme la suite du tarif HT, a la maniere d'un
         devis (« 825.00 HT, soit 891.83 TTC »). Meme structure que
         snippets/price-ttc.liquid. */
      var lead = document.createElement('span');
      lead.className = 'tax-incl__lead';
      lead.textContent = window.FOG_I18N.t('products.tax.ttc_lead');
      var amount = document.createElement('span');
      amount.className = 'tax-incl__amount';
      var label = document.createElement('span');
      label.className = 'tax-incl__label';
      label.textContent = S.label;
      /* Espaces insecables entre les trois parties : l'ecart visuel vient du CSS,
         mais sans ces caracteres le texte copie donne « soitCHF 31.35TTC ». Le
         pendant Liquid les obtient par les sauts de ligne entre les balises. */
      el.appendChild(lead);
      el.appendChild(document.createTextNode('\u00a0'));
      el.appendChild(amount);
      el.appendChild(document.createTextNode('\u00a0'));
      el.appendChild(label);
      container.appendChild(el);
    }

    el.querySelector('.tax-incl__amount').textContent = text;
    return el;
  }

  window.FOG_TTC = {
    mode: S.mode,
    /* Conserve pour les consommateurs qui testent l'activation : vrai des qu'un
       TTC s'affiche, sous une forme ou une autre. */
    enabled: S.mode !== 'ht',
    rate: S.rate,
    label: S.label,
    note: S.note,
    toTtcCents: toTtcCents,
    displayCents: displayCents,
    apply: apply
  };
})();
